import { render, staticRenderFns } from "./IbLoadingSpinner.vue?vue&type=template&id=7cd16026&scoped=true"
import script from "./IbLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./IbLoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./IbLoadingSpinner.vue?vue&type=style&index=0&id=7cd16026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd16026",
  null
  
)

export default component.exports